window.ytPlayers = window.ytPlayers || {};

// ---------------------------
// Pause all media in carousel
// ---------------------------
function pauseAllMedia(scope = document) {
  scope.querySelectorAll('.js-shopify-video').forEach(video => {
    video.pause();
    video.currentTime = 0;
  });

  scope.querySelectorAll('.js-youtube').forEach(yt => {
    yt.contentWindow?.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      '*'
    );
  });

  scope.querySelectorAll('.js-vimeo').forEach(vimeo => {
    vimeo.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), '*');
  });
}

// ---------------------------
// Mute all media + update toggle buttons
// ---------------------------
function muteAllMedia(scope = document) {
  scope.querySelectorAll('.js-shopify-video').forEach(video => {
    video.muted = true;
    video.classList.add('muted');
    video.removeAttribute('data-active-video');
  });

  scope.querySelectorAll('.js-youtube').forEach(yt => {
    if (window.ytPlayers[yt.id]) window.ytPlayers[yt.id].mute();
    yt.classList.add('muted');
    yt.removeAttribute('data-active-video');
  });

  scope.querySelectorAll('.js-vimeo').forEach(vimeo => {
    vimeo.contentWindow?.postMessage(JSON.stringify({ method: 'setVolume', value: 0 }), '*');
    vimeo.classList.add('muted');
    vimeo.removeAttribute('data-active-video');
  });

  // Reset all mute toggle buttons
  document.querySelectorAll('.video-mute-toggle').forEach(btn => {
    btn.classList.remove('unmuted');
    btn.setAttribute('aria-label', 'Unmute video');
  });
}

// ---------------------------
// Create YouTube instance if not already
// ---------------------------
async function createYtInstance(yt) {
  if (window.ytPlayers[yt.id]) return;

  await new Promise(resolve => {
    const check = () => (window.YT?.loaded === 1 ? resolve() : setTimeout(check, 300));
    check();
  });

  window.ytPlayers[yt.id] = new YT.Player(yt, {
    events: {
      onReady: e => {
        e.target.mute();
        e.target.playVideo();
      },
      onStateChange: e => {
        if (e.data === YT.PlayerState.ENDED) {
          e.target.playVideo(); // loop manually if needed
        }
      }
    }
  });
}

// ---------------------------
// Play active slide media
// ---------------------------
async function playActiveSlideMedia(carousel, embla) {
  pauseAllMedia(carousel);
  muteAllMedia(carousel);

  const index = embla.selectedScrollSnap();
  const slide = embla.slideNodes()[index];
  if (!slide) return;

  // Shopify video
  const shopifyVideo = slide.querySelector('.js-shopify-video');
  if (shopifyVideo) {
    shopifyVideo.muted = true;
    shopifyVideo.classList.remove('muted');
    shopifyVideo.setAttribute('data-active-video', 'true');
    shopifyVideo.play().catch(() => {});
  }

  // YouTube video
  const ytVideo = slide.querySelector('.js-youtube');
  if (ytVideo) {
    if (!window.ytPlayers[ytVideo.id]) await createYtInstance(ytVideo);
    else {
      const player = window.ytPlayers[ytVideo.id];
      player.mute();
      player.playVideo();
    }
    ytVideo.classList.remove('muted');
    ytVideo.setAttribute('data-active-video', 'true');
  }

  // Vimeo video
  const vimeoVideo = slide.querySelector('.js-vimeo');
  if (vimeoVideo) {
    vimeoVideo.contentWindow.postMessage(JSON.stringify({ method: 'setVolume', value: 0 }), '*');
    vimeoVideo.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
    vimeoVideo.classList.remove('muted');
    vimeoVideo.setAttribute('data-active-video', 'true');
  }
}

// ---------------------------
// Initialize Embla Carousel with media control
// ---------------------------
function initEmblaMediaController() {
  const carousel = document.querySelector('theme-carousel');
  if (!carousel) return;

  const waitForEmbla = () => {
    const embla = carousel.embla;
    if (!embla) return setTimeout(waitForEmbla, 300);

    playActiveSlideMedia(carousel, embla);

    embla.on('select', () => playActiveSlideMedia(carousel, embla));
    embla.on('reInit', () => playActiveSlideMedia(carousel, embla));
  };

  waitForEmbla();
}

// ---------------------------
// Mute / Unmute toggle
// ---------------------------
function setupVideoMuteToggle(carousel) {
  const buttons = document.querySelectorAll('.video-mute-toggle');
  buttons.forEach(btn => {
    btn.addEventListener('click', async () => {
      const isUnmuted = btn.classList.contains('unmuted');

      // Reset all media first
      muteAllMedia(carousel);

      if (!isUnmuted) {
        btn.classList.add('unmuted');
        btn.setAttribute('aria-label', 'Mute video');

        const embla = carousel.embla;
        if (!embla) return;

        const index = embla.selectedScrollSnap();
        const activeSlide = embla.slideNodes()[index];
        if (!activeSlide) return;

        // Shopify video
        const shopifyVideo = activeSlide.querySelector('.js-shopify-video');
        if (shopifyVideo) {
          shopifyVideo.muted = false;
          shopifyVideo.classList.remove('muted');
          shopifyVideo.setAttribute('data-active-video', 'true');
          shopifyVideo.play().catch(() => {});
          return;
        }

        // YouTube
        const ytVideo = activeSlide.querySelector('.js-youtube');
        if (ytVideo) {
          if (!window.ytPlayers[ytVideo.id]) await createYtInstance(ytVideo);
          const player = window.ytPlayers[ytVideo.id];
          player.unMute();
          player.playVideo();
          ytVideo.classList.remove('muted');
          ytVideo.setAttribute('data-active-video', 'true');
          return;
        }

        // Vimeo
        const vimeoVideo = activeSlide.querySelector('.js-vimeo');
        if (vimeoVideo) {
          vimeoVideo.contentWindow.postMessage(JSON.stringify({ method: 'setVolume', value: 1 }), '*');
          vimeoVideo.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
          vimeoVideo.classList.remove('muted');
          vimeoVideo.setAttribute('data-active-video', 'true');
        }
      } else {
        // Reset toggle to muted
        btn.classList.remove('unmuted');
        btn.setAttribute('aria-label', 'Unmute video');
      }
    });
  });
}

// ---------------------------
// DOM ready
// ---------------------------
document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('theme-carousel');
  initEmblaMediaController();
  setupVideoMuteToggle(carousel);
});